import { DataTableSkeleton } from '@Components/General/Skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { donationsQueryOptions } from '@utils/queryOptions';
import Donations from '@Views/Donations/Donations';

export const Route = createFileRoute('/donations/')({
    component: Donations,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            donationsQueryOptions(opts.deps),
        ),
    loaderDeps: ({ search }) => search,
    pendingComponent: DataTableSkeleton,
});
